import { useUser } from '@/hooks/api/use-user';

/**
 * Fonctionnalités de gestion suspendues (campagne de prélèvements en cours).
 *
 * Servi par `GET /api/v2/perso/me` (`features_disabled`) : la v1 le lisait sur `features.status`
 * par un appel dédié.
 */
export const useFeaturesDisabled = (): boolean => useUser().data?.features_disabled === true;
